module.exports = __webpack_public_path__ + "static/media/features-split-image-01.8ceef6e2.png";